import {React, useState, useEffect, useContext} from "react";
import AuthContext from "../context/userAuth.context";

const Timer = (props) => {
    const {initialMinute = 0,initialSeconds = 0, className = "TimerText"} = props;
    const [ minutes, setMinutes ] = useState(initialMinute);
    const [seconds, setSeconds ] =  useState(initialSeconds);
    const { Tip, authenticationData, setAuthenticationData, apiBaseurl, ExpiryCountdown, setExpiryCountdown } = useContext(AuthContext)

    useEffect(()=>{
    let myInterval = setInterval(() => {
            if (seconds > 0) {
                setSeconds(seconds - 1);
            }
            if (seconds === 0) {
                if (minutes === 0) {
                    clearInterval(myInterval);                    
                    setAuthenticationData({
                        authenticateData: {},
                        ApiBaseURL: apiBaseurl,
                        isAuthenticated: false,
                    });
                    setExpiryCountdown(false);
                } else {
                    setMinutes(minutes - 1);
                    setSeconds(59);
                }
            } 
        }, 1000)
        return ()=> {
            clearInterval(myInterval);
          };
    });

    return (
        <>
        { minutes === 0 && seconds === 0
            ? null
            : <span className = {className}> {minutes}:{seconds < 10 ?  `0${seconds}` : seconds}</span> 
        }
        </>
    )
}

export default Timer;